{% block verign_dv_accessibility_sw_premium_description %}
    <div class="premium-sub-container">
        <div v-if="hideText == false">
            <p>{{ premiumPurchasedDescription }}</p>
        </div>
        <div v-else>
            <p>{{ premiumDescription }}</p>
        </div>
        <sw-entity-purchase-button v-if="hideText == false"></sw-entity-purchase-button>
    </div>
{% endblock %}